import { apiCredSystem } from '~/credsystem/services/apiCredSystem';

interface CreatesUserAccessUseCaseParams {
  password: string;
}

interface APIResponse {
  httpStatusCode: number;
  data: {
    tokenSMS: {
      tokenSmsValido: boolean;
    };
    biometria: {
      mensagem: string;
    };
    fingerPrint: {
      mensagem: string;
    };
  };
}

export async function createsUserAccessUseCase({
  password,
}: CreatesUserAccessUseCaseParams): Promise<APIResponse | null> {
  try {
    const response = await apiCredSystem.post<APIResponse>(
      `/api/v1/usuario/acesso`,
      {
        senha: password,
      }
    );

    return response?.data;
  } catch (error) {
    return null;
  }
}
